let storage = window.sessionStorage

const Session = {
  add(name, value){
    storage.setItem(name, value)
  },
  get(name){
    return storage.getItem(name)
  },
  remove(name){
    storage.removeItem(name)
  },
  clear(){
    storage.clear()
  }
}

export default Session